import { injectable, inject } from 'inversify';
import dataroomUrl from '@/dataroom/infrastructure/dataroomUrl';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import { DataroomTenantContextSymbol, type IDataroomTenantContext } from '@dataroom/tenant/types';
import { validateDataroomTenant } from '@dataroom/tenant/validateDataroomTenant';
import Container from '@framework/di/Container';
import { UploadDispatcher, SinglepartUploadStrategy, DataroomUploadAdapter } from '@dealroadshow/file-uploader';

@injectable()
class FileUploadDispatcherFactory {
  constructor(
    @inject(Container) private readonly container: Container,
  ) {}

  create = (tenantCode: DataroomTenant | null = null) => {
    const tenant = tenantCode || this.container.get<IDataroomTenantContext>(DataroomTenantContextSymbol).tenant;

    validateDataroomTenant(tenant);

    const dataroomUploadAdapter = new DataroomUploadAdapter({
      url: dataroomUrl(tenant)
        .getUploadFileUrl(),
    });
    return new UploadDispatcher(new SinglepartUploadStrategy(dataroomUploadAdapter));
  };
}

export default FileUploadDispatcherFactory;
